// @ts-nocheck
import React from 'react'


const Title = ({ placeholder, label, compact = false }) => {

    return (
        <>
            <div className={`${compact ? 'm-0 p-3' : 'm-2 mr-5 p-4'} w-full overflow-hidden rounded border bg-white shadow`}>
                <div className={`flex flex-col items-start justify-center text-left ${compact ? 'p-1' : 'p-3'}`}>
                    <header className="font-bold leading-tight">
                        <div className={`${compact ? 'text-2xl break-words' : 'text-3xl'} mb-1 font-bold text-black`}>{label}</div>
                        <div className={`${compact ? 'mb-1 leading-5' : 'mb-3'} break-words text-sm font-normal text-black`}>{placeholder}</div>
                    </header>
                </div>
                </div>
            </>
            );
};

            export default Title;
